import { cn } from "@/lib/helpers/cn";

type IdentityDocumentPreviewImageProps = {
  isImageLoaded: boolean;
  onImageLoad: VoidFunction;
  src: string;
};

export function IdentityDocumentPreviewImage({
  isImageLoaded,
  onImageLoad,
  src,
}: IdentityDocumentPreviewImageProps) {
  return (
    <img
      className={cn(
        "tw:h-full tw:w-auto tw:object-contain",
        isImageLoaded ? "tw:block" : "tw:hidden",
      )}
      onLoad={onImageLoad}
      src={src}
      title="Identity Document Preview"
    />
  );
}
